module.exports = __webpack_public_path__ + "static/modified-undraw-process-9ea010aa18e5b43fb5c17d3745e27dd0.svg";